export default function HomeHero() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="relative min-h-[680px] md:min-h-[780px] flex items-center bg-primary-950 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20layered%20architectural%20forms%20and%20soft%20geometric%20planes%20in%20deep%20navy%20teal%20and%20warm%20sand%20tones%2C%20elegant%20minimal%20corporate%20backdrop%20with%20subtle%20depth%20and%20cinematic%20soft%20lighting%2C%20high-end%20editorial%20style%2C%20smooth%20gradients&width=1600&height=900&seq=penland-home-hero-01&orientation=landscape"
          alt="Abstract layered forms representing the Penland LLC group of businesses"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/95 via-primary-950/85 to-primary-950/60" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-32 pb-20 md:pt-40 md:pb-28">
        <div className="max-w-5xl">
          <h1 className="font-heading text-4xl md:text-5xl xl:text-6xl text-background-50 font-bold leading-[1.1] mb-6">
            <span className="lg:whitespace-nowrap">One Company. Many Solutions.</span>
            <br />
            <span className="text-accent-400">Decades of experience.</span>
          </h1>
          <p className="text-background-200 text-base md:text-lg leading-relaxed max-w-2xl mb-8">
            Bookkeeping, consulting, property management, software, and travel, all from one
            experienced and focused team.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => scrollTo('#divisions')}
              className="inline-flex items-center justify-center gap-2 bg-accent-500 hover:bg-accent-400 text-primary-950 text-sm md:text-base font-bold px-8 py-4 rounded-full transition-all whitespace-nowrap"
            >
              Explore Our Divisions
              <i className="ri-arrow-down-line" />
            </button>
            <button
              onClick={() => scrollTo('#contact')}
              className="btn-shine btn-shine--light inline-flex items-center justify-center gap-2 bg-transparent border-2 border-background-300/60 text-background-50 hover:bg-background-50/10 text-sm md:text-base font-semibold px-8 py-4 rounded-full transition-all whitespace-nowrap"
            >
              <i className="ri-mail-line" />
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}